export default {
  existing_documents: {
    description:
      'Hai già caricato i seguenti documenti. Selezionane uno e premi invia, oppure carica un nuovo documento.',
    sides: {
      front: 'Fronte',
      back: 'Retro',
    },
    created_at: 'Caricato: {{date}}',
    expires_at: 'Scade: {{date}}',
  },
  document_types: {
    owner_document: "Documento d'identità del titolare",
    business_document: 'Documento aziendale',
  },
  form: {
    document_type: {
      label: 'Documento di prova aziendale',
      placeholder: 'Seleziona tipo di documento',
      options: {
        vat_registration: 'Registrazione IVA',
        trade_registration: 'Registrazione commerciale',
        trade_license: 'Licenza commerciale',
        commercial_register_extract: 'Estratto registro commerciale',
        financial_statements: 'Bilanci finanziari',
        other: 'Altro',
      },
    },
    front: {
      label: 'Fronte documento',
    },
    back: {
      label: 'Retro documento (opzionale per alcuni documenti)',
    },
    expires_at: {
      label: 'Data di scadenza documento',
      placeholder: 'Seleziona data di scadenza',
    },
  },
  buttons: {
    select_file: 'Seleziona file',
    next: 'Avanti',
    back: 'Retro',
    send: 'Invia',
    upload_new: 'Carica nuovo documento',
    use_existing: 'Usa un documento caricato',
  },
};
